import {
  Component,
  ElementRef,
  EventEmitter,
  forwardRef,
  Input,
  OnInit,
  Output,
  ViewChild,
  ChangeDetectionStrategy,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { provideNgxMask } from 'ngx-mask';

@Component({
  selector: 'app-price-field',
  templateUrl: './price-field.component.html',
  styleUrls: ['./price-field.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => PriceFieldComponent),
    },
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class PriceFieldComponent implements OnInit, ControlValueAccessor {
  @Input() defaultActive = false;
  @Input() isEdit = false;
  @Input() actionBtn = true;
  @Input() defaultValue: string = '';
  @Input() label: string = '';
  @Input() customClass: string = '';
  @Input() placeholder: string = '';
  @Input() mask: string = '';
  @Input() maxLength!: number;
  @Input() disabled: boolean = false;
  @Input() border: boolean = false;
  @Input() leadZero: boolean = false;
  @Input() size: 'small' | 'default' | 'big' = 'default';
  @Input() type: 'hidden' | 'default' = 'default';
  @Input() required: boolean = false;
  @Input() Error: boolean = false;

  @Output() onChangeClick = new EventEmitter();
  @Output() onChangeSave = new EventEmitter();
  @Output() onChangeCancel = new EventEmitter();
  @Output() onValueChange = new EventEmitter();

  @ViewChild('inputRef', { static: false }) inputRef!: ElementRef;

  @Input() input: string = '';
  copyInput: string = '';

  ngOnInit(): void {}

  onChange = (data: any) => {};
  onTouch = (_: any) => {};

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  writeValue(value: string) {
    this.input = value;
    this.onChange(value);
  }

  /**
   *Func triggered on input change
   */
  onchange(event: any) {
    this.input = event;
    this.onChange(event);
    this.onValueChange.emit(event);
  }

  click() {
    if (!this.isEdit) {
      this.isEdit = true;
      this.copyInput = this.input;
      this.onChangeClick.emit();
      setTimeout(() => {
        this.inputRef.nativeElement.focus();
      }, 100);
    }
  }

  save() {
    this.isEdit = false;
    this.defaultValue = this.input;
    this.onChangeSave.emit(this.input);
  }

  cancel() {
    this.isEdit = false;
    this.input = this.copyInput;
    this.onChangeCancel.emit();
  }
}
